/**
 * DEMO — doet alsof de server even nadenkt. Elk antwoord van de demo-backend
 * loopt hierlangs, zodat laad- en verzendtoestanden in de demo echt te zien zijn.
 */
export function reply<T>(value: T, ms = 400): Promise<T> {
  return new Promise((resolve) => window.setTimeout(() => resolve(value), ms))
}

/** Een id zoals de server die zou geven, bijv. "BB-LX3K9Q". */
export const demoId = (prefix: string) => `${prefix}-${Date.now().toString(36).toUpperCase()}`
